
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getAnalyticsData, validateAPIKey } from '../../../utils/analyticsApi';

export default function AnalyticsAPIPage() {
  const [searchParams] = useSearchParams();
  const [response, setResponse] = useState<unknown>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const apiKey    = searchParams.get('api_key');
    const startDate = searchParams.get('start') || undefined;
    const endDate   = searchParams.get('end')   || undefined;

    setLoading(true);
    validateAPIKey(apiKey)
      .then(valid => {
        if (!valid) {
          setResponse({ error: 'Unauthorized', message: 'Invalid or missing API key. Generate one in the dashboard under API Keys.', status: 401 });
          setLoading(false);
          return;
        }
        return getAnalyticsData(startDate, endDate)
          .then(data => setResponse({ success: true, data, timestamp: new Date().toISOString() }))
          .catch(err  => setResponse({ error: 'Internal Server Error', message: err instanceof Error ? err.message : 'Unknown error', status: 500 }));
      })
      .finally(() => setLoading(false));
  }, [searchParams]);

  return (
    <div style={{ fontFamily: 'monospace', padding: '20px', backgroundColor: '#1a1a1a', color: '#00ff00', minHeight: '100vh' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <h1 style={{ color: '#00ff00', marginBottom: '20px' }}>📊 Analytics API Endpoint</h1>

        <div style={{ backgroundColor: '#2a2a2a', padding: '20px', borderRadius: '8px', marginBottom: '20px', border: '1px solid #00ff00' }}>
          <h2 style={{ color: '#00ff00', marginBottom: '10px' }}>Usage:</h2>
          <p style={{ color: '#cccccc', marginBottom: '10px' }}><strong>Endpoint:</strong> /api/analytics</p>
          <p style={{ color: '#cccccc', marginBottom: '10px' }}>
            <strong>API Key:</strong>{' '}
            <span style={{ color: '#888' }}>Generate keys in the dashboard → API Keys tab</span>
          </p>
          <p style={{ color: '#cccccc', marginBottom: '10px' }}>
            <strong>Example:</strong>{' '}
            <code style={{ backgroundColor: '#1a1a1a', padding: '2px 6px', borderRadius: '4px' }}>
              /api/analytics?api_key=YOUR_KEY&amp;start=2024-01-01&amp;end=2024-12-31
            </code>
          </p>
          <p style={{ color: '#cccccc' }}><strong>Query Parameters:</strong></p>
          <ul style={{ color: '#cccccc', marginLeft: '20px' }}>
            <li><code>api_key</code> (required) — Authentication key from the dashboard</li>
            <li><code>start</code> (optional) — Start date (YYYY-MM-DD)</li>
            <li><code>end</code> (optional) — End date (YYYY-MM-DD)</li>
          </ul>
          <p style={{ color: '#888', marginTop: '12px', fontSize: '13px' }}>
            ✅ Data source: <strong style={{ color: '#00ff00' }}>Supabase (live, persistent)</strong>
          </p>
        </div>

        <div style={{ backgroundColor: '#2a2a2a', padding: '20px', borderRadius: '8px', border: '1px solid #00ff00' }}>
          <h2 style={{ color: '#00ff00', marginBottom: '10px' }}>Response:</h2>
          {loading ? (
            <p style={{ color: '#888' }}>Validating key &amp; loading data from Supabase…</p>
          ) : (
            <pre style={{ backgroundColor: '#1a1a1a', padding: '15px', borderRadius: '4px', overflow: 'auto', color: '#00ff00', fontSize: '14px', lineHeight: '1.5' }}>
              {JSON.stringify(response, null, 2)}
            </pre>
          )}
        </div>
      </div>
    </div>
  );
}
